import React from 'react';
import { fieldPropTypes } from '../shapes';

const Checkbox = ({
  id,
  label,
  onChange,
  name,
  required,
}) => (
  <div className="c-checkbox">
    <input
      className="c-checkbox__input"
      type="checkbox"
      {...{ id, onChange, name, required }}
    />
    <label className="c-checkbox__mark" htmlFor={id} />
    <label className="c-checkbox__label" htmlFor={id}>
      <span className="c-checkbox__text">
        {label}
      </span>
    </label>
  </div>
);
Checkbox.propTypes = fieldPropTypes;
Checkbox.defaultProps = {
  name: '',
  required: false,
  onChange: null,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/app/components/Checkbox.jsx